/**
 * ApiClient - Handles all AJAX requests to WordPress backend
 */
export class ApiClient {
    constructor() {
        this.ajaxUrl = window.docuswiftPortal?.ajax_url || '/wp-admin/admin-ajax.php';
        this.nonce = window.docuswiftPortal?.nonce || '';
    }

    /**
     * Generic POST request
     */
    async post(action, data = {}) {
        const formData = new URLSearchParams();
        formData.append('action', action);
        formData.append('nonce', this.nonce);

        // Append all data
        Object.keys(data).forEach(key => {
            const value = data[key];
            formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
        });

        try {
            const response = await fetch(this.ajaxUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formData.toString()
            });

            return await response.json();
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }

    /**
     * POST request with FormData (for file uploads)
     */
    async postFormData(formData) {
        if (!formData.has('nonce')) {
            formData.append('nonce', this.nonce);
        }

        try {
            const response = await fetch(this.ajaxUrl, {
                method: 'POST',
                body: formData
            });

            return await response.json();
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }
}

// Export singleton instance
export const apiClient = new ApiClient();

